<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'" >
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ $t('invoices.invoices_issuing.add_irpf') }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 overflow-x-auto overflow-y-auto">
        <el-form :model="form" ref="ruleForm" :rules="rules">
          <div class="flex-1">

            <div class="flex-row lg:mb-2">
              <div >
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('app.name') }}</label>
                <el-form-item prop="name">
                  <el-input
                    clearable class="w-full" v-model="form.name" maxlength='30'
                  />
                </el-form-item>
              </div>

              <div >
                <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{ $t('impuestos.TaxRate') }}</label>
                <el-form-item prop="taxRate">
                  <el-input clearable class="w-full" v-model="form.taxRate" maxlength='30' type="number">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="flex flex-row w-full justify-between">
        <base-button class="w-full mx-2" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button mode="secondary-phantom-blue" class="w-full mx-2" :text="$t('app.save')" @click="addIRPF('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>

import { i18n } from '@/i18n'


export default {
  /* eslint-disable camelcase */
  name: 'new-irpf-dialog',
  components: { },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    idCliente: [String, Number]
  },
  data: function () {
    return {
      searchView: false,
      isOpen: this.dialogOpen,
      activeName: 'es',
      form: this.getDefaultForm(),
      rules: {
        name: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'] 
          }
        ],
        taxRate: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: ['blur', 'change'] 
          }
        ]
      },
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value !== oldValue) {
        this.isOpen = value
        this.resetForm()
      }
    },
  },
  methods: {
    getDefaultForm: function () {
      return {
        name: '',
        taxRate: '',
      }
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('toggleDialog')
    },
    resetForm () {
      this.form = this.getDefaultForm()
    },
    addIRPF: function (ruleForm) {
      try {
        this.$store.commit('setIsLoading', true)
        this.$refs[ruleForm].validate(async valid => {
          if (!valid) {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          } else {
            const params = {
              TaxType: '04',
              idCliente: this.idCliente || null,
              idImpuesto: null,
              Name: this.form.name,
              TaxRate: parseFloat(this.form.taxRate)
            }
            this.$emit('applyDialog', params)
          }
        })
      } catch (error) {
        this.isLoadingUpdate = false
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
  }
}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
.modal-overlay{
  z-index: 300;
}
</style>
